import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState, useCallback } from 'react';
var useBoolean = function useBoolean(initialState) {
  var _useState = useState(Boolean(initialState)),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var setTrue = useCallback(function () {
    return setState(true);
  }, []);
  var setFalse = useCallback(function () {
    return setState(false);
  }, []);
  return [state, setTrue, setFalse];
};
export default useBoolean;